import React from "react"
import { Badge } from "@shopify/polaris"
import { useTranslation } from "react-i18next"
import PropTypes from "prop-types"

// A maturity score is good above 75% and needs improvement below 50%, strictly
// (75 and 50 stay "standard", which is why this is not a ChartBadge wrapper:
// ChartBadge compares inclusively).
const GOOD_ABOVE = 75
const TO_IMPROVE_BELOW = 50

export const maturityStatus = (
  value,
  lowerLimit = TO_IMPROVE_BELOW,
  upperLimit = GOOD_ABOVE
) => {
  if (value == null) return null
  if (value > upperLimit) return "success"
  if (value < lowerLimit) return "critical"
  return "info"
}

const MaturityBadge = ({ value, lowerLimit, upperLimit }) => {
  const { t } = useTranslation()

  const status = maturityStatus(value, lowerLimit, upperLimit)
  if (status == null) return null

  return (
    <Badge size="medium" status={status}>
      {t(`score:badge.status.${status}`)}
    </Badge>
  )
}

MaturityBadge.propTypes = {
  value: PropTypes.number,
  lowerLimit: PropTypes.number,
  upperLimit: PropTypes.number,
}

export default MaturityBadge
